import { render } from "./DeepResearchAgent.vue?vue&type=template&id=a244f6b6&scoped=true"
import script from "./DeepResearchAgent.vue?vue&type=script&lang=js"
export * from "./DeepResearchAgent.vue?vue&type=script&lang=js"

import "./DeepResearchAgent.vue?vue&type=style&index=0&id=a244f6b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a244f6b6"]])

export default __exports__